import React, {useEffect, useState} from 'react';
import {QuizStartPage} from "./quiz/QuizStartPage";
import {TextContent} from "../routes/course/TextContent";
import {InteractiveTextArea} from "./input/InteractiveTextArea";
import {AIFeedback} from "./AIFeedback";
import {TaskSolution} from "./TaskSolution";
import {FeedbackItem} from "./FeedbackItem";
import {Link} from "react-router-dom";
import ImageContent from "../routes/course/ImageContent";


export function LandingPage() {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setLoading(true)
        }, 2000)
    }, []);


    const tags = [{text:"Beregninger"}, {text:"Titrering"}, {text:"Terminologi"}, {text:"Reaksjonstyper"}, {text:"Forsøk"}, {text:"Syre-base"}];
    const highscore = 89;
    const quizDescription = "I denne quizen skal du teste kunnskapene dine om kvantitativ analyse, et sentralt tema i Kjemi 1. Du vil møte spørsmål som handler om beregning av stoffmengde, masse, konsentrasjon og fortynning, samt tolkning av resultater fra titrering og felling.";
    const taskFeedback = "Du har gjort et godt forsøk og riktig identifisert at du trenger tre HCl for å få AlCl₃, men legg merke til at du får dannet H2, som består av to hydrogenatomer. Siden du har tre HCl, får du tre hydrogenatomer, og det går ikke opp med H2 på høyre side."

    return (
        <div className={""} style={{fontFamily:"Poppins"}}>
            <div className={"container d-flex flex-column align-items-center justify-content-center"}>
                    <div className={"row mt-4"} >
                        <div className={"col d-flex flex-column align-items-center justify-content-start pe-5 pt-5"}>
                            <div className={"m-0 "} style={{margin: "32px"}}>
                                <h1 style={{fontSize: "3rem"}}>
                                    Trenger <strong>karakterene</strong> dine en <strong>boost</strong>?
                                </h1>
                                <p className={"text-muted mt-4"}>
                                    Benytt deg av kurs som er designet av tidliger 6-er studenter, med er lett og kortfattet format for å få med seg det
                                    essensielle av pensum. Pugg videre med både quiz og oppgaver.
                                </p>
                            </div>

                            <div className={"row w-100 mt-4 "}>
                                <Link to={"/butikk"} className={"col btn btn-primary me-3 py-3 rounded-5 text-white"}>Finn ditt kurs</Link>
                                <Link to={"/signup"} className={"col btn btn-outline-secondary py-3 rounded-5"}>Lag bruker</Link>
                            </div>
                        </div>
                        <div className={"col"} >
                        </div>

                    </div>
                <p className={"lh-lg my-5"}>
                    Utforsk en ny måte å lære på med vår innovative utdanningsplattform! Vi tilbyr
                    omfattende <strong>notater</strong> og kurs i ulike videregående fag, samt <strong>quizzer</strong> og oppgaver til hvert
                    kapittel. Med <strong>integrert kunstig intelligens</strong> får du personlig tilpasset tilbakemelding og oppgaver som
                    hjelper deg å mestre stoffet.
                </p>

                <div className={"row "} style={{minHeight:"50vh"}}>
                    <div className={"col d-flex flex-column  justify-content-center px-5"}>
                        <h2 className={"text-primary"}>Kurs</h2>
                        <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC.</p>
                    </div>
                    <div className={"col"}></div>
                </div>

                <div className={"row "} style={{minHeight:"50vh"}}>
                    <div className={"col d-flex flex-column  justify-content-center"}>
                        <div className={"border  rounded p-2 px-4 bg-white"}>
                            <QuizStartPage name={"Kvantitativ analyse"} description={quizDescription} highscore={highscore} questionCount={25} tags={tags}/>
                        </div>
                    </div>
                    <div className={"col d-flex flex-column  justify-content-center px-5"}>
                        <h2 className={"text-primary"} >Quiz</h2>
                        <p>
                            For å holde kunnskapen vedlike, kan det være greit å utfordre seg selv.
                            Test deg selv med quiz innenfor mange ulike temaer i pensum. Klarer du
                            å få 100% score på alle?
                        </p>
                    </div>

                </div>

                <div className={"row my-5"} style={{minHeight:"50vh"}}>
                    <div className={"col d-flex flex-column  justify-content-center px-5"}>
                        <h2 className={"text-primary"}>Oppgaver</h2>
                        <p>
                            Gjennom kurset har du mulighet til å prøve deg på massevis av oppgaver.
                            Gi ditt beste forsøk og få umiddelbar tilbakemelding. Dersom
                            du har lyst, kan du prøve igjen, men hvis du sitter skikkelig fast, kan
                            du alltid ta en titt på løsningsforslaget.
                        </p>
                    </div>
                    <div className={"col d-flex flex-column  justify-content-center"}>

                        <div className={"mb-3 subtask "} >
                            <div className={" mb-3 p-2"}>
                                <div className={"fw-bold mb-3"}>
                                    <TextContent value={"Balanser reaksjonslikningen: $\\ce{Al + HCl -> AlCl3 + H2}$"}/>
                                </div>
                                <InteractiveTextArea
                                    value={`$\\ce{Al + 3HCl -> AlCl3 + H2}$`}
                                    setValue={() => {}}
                                    placeholder={"Ditt løsningsforslag (tekst eller latex)"}
                                    disabled={true}
                                ></InteractiveTextArea>
                                <AIFeedback show={true} totalPoints={1} maxPoints={2} feedback={taskFeedback}/>
                                <TaskSolution show={true} solution={"$\\ce{2Al + 6HCl -> 2AlCl3 + 3H2}$"}/>
                            </div>
                        </div>

                        </div>
                </div>

                <div className={"row "} style={{minHeight:"50vh"}}>

                    <div className={"col d-flex flex-column  justify-content-center"}>
                        <FeedbackItem text={"Kan korrekt beskrive metallbindingers egenskaper, spesielt vedrørende elektrisk ledningsevne, som indikerer solid kunnskap om metallers struktur."} type={"STRENGTH"} date={"03-03-2025"} isNew={false}/>
                        <FeedbackItem text={"Eleven bør også arbeide med å utvikle evnen til å kommunisere klare og konsise svar; noen svar er lange, men innholdet kan være upresist."} type={"IMPROVEMENT"} date={"03-03-2025"} isNew={false}/>
                    </div>
                    <div className={"col d-flex flex-column  justify-content-center px-5"}>
                        <h2 className={"text-primary"}>Evalueringsplattform</h2>
                        <p>
                            Noen ganger kan det være vanskelig å vite hva man burde fokusere på.
                            Heldigvis får du oversikt over dine svar på quizzer og oppgaver i
                            ditt dashboard. Her kan du se hvilke temaer du burde fokusere mest på.
                            I tillegg får du jevnlige vurderinger av dine prestasjoner av vår KI-bot,
                            som skal gi deg ett bedre perspektiv på dine positive og negative evner.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );

}